import { RequestService } from '../../../../../common/services/RequestService';
import { ENTERTAINMENTS_GET } from '../../constants';

export const getEntertainmentsRequest = payload => {
  return RequestService.get(ENTERTAINMENTS_GET);
};
